import React, { useState, useEffect } from 'react';
// ux
import LoadingAnimation from './LoadingAnimation';

const ListItem = ({
  fuse,
  isOpen,
  onDropdownToggle,
  handleOpenModal,
  loading
}) => {
  const totalBars = 24;
  const [activeBars, setActiveBars] = useState(Array(totalBars).fill(false));
  const [scoreClass, setScoreClass] = useState('fuse-score');
  const [fuseScore, setFuseScore] = useState(0);

  useEffect(() => {
    if (fuse.ignition_thrust) {
      const scoreNumber = fuse.ignition_thrust * 100;
      if (scoreNumber > 3000) {
        setFuseScore('30X+');
      } else if (scoreNumber > 500) {
        setFuseScore((scoreNumber / 100).toFixed(1) + 'X');
      } else {
        setFuseScore(Math.round(fuse.ignition_thrust * 100) + '%');
      }
    }

    if (fuse.ignition_context) {
      const ignitionContext = fuse.ignition_context;
      const scoreCeiling = parseFloat(ignitionContext['Scale Celing']) || 100; // Default to 100 if undefined
      const scorePercentage = (fuse.ignition_thrust * 100 * 100) / scoreCeiling;
      const percentageIndex = Math.ceil((scorePercentage * totalBars) / 100);
      const updatedActiveBars = Array(totalBars)
        .fill(false)
        .map((_, index) => index < percentageIndex);
      setActiveBars(updatedActiveBars);

      if (updatedActiveBars.filter((bar) => bar).length < 6) {
        setScoreClass('fuse-score low');
      } else if (updatedActiveBars.filter((bar) => bar).length < 13) {
        setScoreClass('fuse-score mid-low');
      } else if (updatedActiveBars.filter((bar) => bar).length < 20) {
        setScoreClass('fuse-score mid-high');
      } else {
        setScoreClass('fuse-score high');
      }
    }
  }, [fuse]);

  return (
    <li
      className={
        loading
          ? 'fuselight-list-item fuse-item-loading'
          : 'fuselight-list-item'
      }
    >
      <div className="fuse-info">
        {fuse.brand_name} + {fuse.celebrity_name}{' '}
        <span className={scoreClass}>{fuseScore}</span>
      </div>
      {loading ? (
        <div className="list-item-loading">
          <LoadingAnimation />
        </div>
      ) : (
        <div className="dropdown-container">
          <button className="dots" onClick={onDropdownToggle}>
            <div></div>
            <div></div>
            <div></div>
          </button>
          {isOpen && (
            <div className="list-item-dropdown">
              <button onClick={() => handleOpenModal('share', fuse)}>
                Share <i className="fas fa-external-link-square-alt"></i>
              </button>
              <button onClick={() => handleOpenModal('delete', fuse)}>
                Delete <i className="fas fa-trash-alt"></i>
              </button>
            </div>
          )}
        </div>
      )}
    </li>
  );
};

export default ListItem;
